import { type TransactionHash, type TokenId, TRANSACTION_TYPES, EVENT_SUFFIXES } from "@/types";
import { createEventEmitter } from "@/events";

export const STAKE_EVENTS = {
    SUCCESS: `${TRANSACTION_TYPES.STAKE}:${EVENT_SUFFIXES.SUCCESS}`,
} as const;

export interface StakeSuccessPayload {
    transactionHash: TransactionHash;
    stakeTokenId: TokenId;
    stakeAmount: number;
}

export interface RewardsEarnedPayload {
    amount: number;
}

export interface StakeEventPayloads extends Record<string, unknown> {
    [STAKE_EVENTS.SUCCESS]: StakeSuccessPayload;
}

export const stakeEventEmitter = createEventEmitter<StakeEventPayloads>();
